import $ from 'jquery'
import settings from './settings'

const toggle = (el) => {
  const $this = $(el)
  const area = $this.attr('data-toggle')
  const $area = $(`.js-toggle[data-area="${area}"]`)

  $area.slideToggle(settings.SPEED, settings.EASING)
}

const enable = () => {
  if ($('[data-toggle]').length) {
    $('[data-toggle]').on('click', (e) => {
      toggle(e.target)

      $(e.target).text((i, text) => (text === 'More' ? 'Less' : 'More'))

      e.preventDefault()
    })
  }
}

export default { enable }
